/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Supplyairmaxtemperaturesetpoint4Inputs */



/**
* | output |
* | --- |
* | "Supply air maximum temperature" |
*
* @param {Ahu_History_Key_Supplyairmaxtemperaturesetpoint4Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_supplyairmaxtemperaturesetpoint4 = /** @type {((inputs?: Ahu_History_Key_Supplyairmaxtemperaturesetpoint4Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Supplyairmaxtemperaturesetpoint4Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Supply air maximum temperature")
	return /** @type {LocalizedString} */ ("Température maximum air soufflé")
});
export { ahu_history_key_supplyairmaxtemperaturesetpoint4 as "ahu_history_key_supplyAirMaxTemperatureSetpoint" }